import { StaffType } from 'types/staff'
import { Action, Dispatch } from 'redux'
import { openStaffModalAction } from 'reducks/modal/actions'

const openStaffModal = (staff: StaffType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openStaffModalAction(staff))
  }
}

export default openStaffModal
